import 'scss/services/face-feature-analysis.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'

initServiceOpen()
$(function () {
  $('.to-service-open').click(function () {
    showserviceOpenModal({
      urlParams: {'currPage': '1'}
    }, {
      detailUrl: `${config.CONSOLE}/app/myapp`,
      appIdKey: 'keyword',
      needBase64: false
    })
  })
  serviceTopbar()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/face-feature-analysis.js